import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/images/parts/loading.gif'


const _withScopeId = n => (_pushScopeId("data-v-f7f59be6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "root"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "gl_ly_main_blank" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "gl_bl_icon",
    src: _imports_0,
    alt: "Loading...",
    loading: "lazy",
    width: "120px",
    height: "120px"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "gl_bl_text" }, "Loading...")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 2,
  class: "root"
}
const _hoisted_5 = {
  class: "main",
  id: "ly_main"
}
const _hoisted_6 = { class: "footer" }
const _hoisted_7 = {
  key: 1,
  class: "ly_action_edit"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 2,
  class: "ly_menu"
}

import PopupComponent from './components/YesNoPopup.vue';

import { onMounted, ref } from 'vue';
import { rootStore } from '@/services/RootStore';
import eventService, { SessionAction } from './services/EventService';
import UserService from './services/UserService';
import { EnumAuthState, firebaseService } from './services/FireAuthService';
import SessionService from './services/SessionService';
import { onUnmounted } from 'vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();


const showDeletePopup = ref(false);
const deletePopupComment = computed(() => {
  return 'RootDictionaryへようこそ！\nもし他の端末などで利用された事があれば、\nログインするとデータの同期ができます♪';
});

const authState = firebaseService.nowAuthState;
console.log("authState", authState);
const showWellcomPopup = computed(() => {

  if (authState.value == EnumAuthState.NotAuthenticated) {
    if (UserService.isRegistered() == false) {
      if (route.path.startsWith('/word/')) {
        return false;
      }
      return true
    }
  }
  return false;
});
const isLoading = computed(() => {

  if (authState.value == EnumAuthState.NotAuthenticated) {
    if (UserService.isRegistered()) {
      firebaseService.signIn()
    }
  }
  if (route.path.startsWith('/word/')) {
    return false;
  }
  return authState.value != EnumAuthState.Authenticated;
});

async function startWithLogin() {
  console.log('startWithLogin');
  await UserService.Register();
  await firebaseService.signIn();
  await firebaseService.signInByGoogle();
}
async function startWithoutLogin() {
  console.log('startWithoutLogin');
  await UserService.Register();
  await firebaseService.signIn()
}
onMounted(async () => {
  const newLocal = SessionService.GetNowMenuType().toString();
  activeItem.value = newLocal;
  eventService.on(SessionAction.ChangeMenuType, onChangeMenu);
});

onUnmounted(() => {
  eventService.off(SessionAction.ChangeMenuType, onChangeMenu);
});

function onChangeMenu(menuType: string) {
  activeItem.value = menuType;
}

const newLocal = SessionService.GetNowMenuType().toString();
const activeItem = ref(newLocal);

function clickMenu(menu: string) {
  activeItem.value = menu;
}

function buttonSelectAll() {
  eventService.emit(SessionAction.SelectAll, "top");
}

function buttonDelete() {
  console.log('buttonDelete');
  showDeletePopup.value = true;
}
function handleConfirm() {
  eventService.emit(SessionAction.Delete, "top");
  showDeletePopup.value = false;
}
function handleCancel() {
  showDeletePopup.value = false;
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showWellcomPopup.value)
      ? (_openBlock(), _createBlock(PopupComponent, {
          key: 0,
          message: deletePopupComment.value,
          cancelTxt: "しないで使う",
          confirmTxt: "ログインする",
          onConfirmed: startWithLogin,
          onCancelled: startWithoutLogin
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_view)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (showDeletePopup.value)
              ? (_openBlock(), _createBlock(PopupComponent, {
                  key: 0,
                  message: deletePopupComment.value,
                  cancelTxt: "キャンセル",
                  confirmTxt: "削除",
                  onConfirmed: handleConfirm,
                  onCancelled: handleCancel
                }, null, 8, ["message"]))
              : _createCommentVNode("", true),
            (_unref(rootStore).sessionState.isEditMode)
              ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "bl_select-all",
                    onClick: buttonSelectAll,
                    innerHTML: _ctx.$t('lt_menu.select-all')
                  }, null, 8, _hoisted_8),
                  _createElementVNode("button", {
                    class: "bl_delete",
                    onClick: buttonDelete
                  })
                ]))
              : (_openBlock(), _createElementBlock("nav", _hoisted_9, [
                  _createVNode(_component_router_link, {
                    to: "/",
                    class: _normalizeClass(["bl_menu-item", { 'active': activeItem.value === 'dictionary' || activeItem.value === 'word' }]),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (clickMenu('dictionary'))),
                    id: "dictionary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('lt_menu.dictionary')), 1)
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_router_link, {
                    to: "/bookmark",
                    class: _normalizeClass(["bl_menu-item", { 'active': activeItem.value === 'bookmark' }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (clickMenu('bookmark'))),
                    id: "bookmark"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('lt_menu.bookmark')), 1)
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_router_link, {
                    to: "/history",
                    class: _normalizeClass(["bl_menu-item", { 'active': activeItem.value === 'history' }]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (clickMenu('history'))),
                    id: "history"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('lt_menu.history')), 1)
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]))
          ])
        ]))
  ], 64))
}
}

})